/**
 * Single chat message bubble.
 */

import React from 'react';
import type { ChatMessage } from '@excel-ai-studio/shared';

interface ChatBubbleProps {
  message: ChatMessage;
}

export const ChatBubble: React.FC<ChatBubbleProps> = ({ message }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: message.role === 'user' ? 'flex-end' : 'flex-start',
      marginBottom: 8,
    }}
  >
    <div
      style={{
        maxWidth: '85%',
        padding: '8px 12px',
        borderRadius:
          message.role === 'user' ? '12px 12px 2px 12px' : '12px 12px 12px 2px',
        background: message.role === 'user' ? 'var(--accent)' : 'var(--card-bg)',
        color: message.role === 'user' ? 'white' : 'var(--text-primary)',
        border: message.role === 'assistant' ? '1px solid var(--border-color)' : 'none',
        fontSize: 13,
        lineHeight: 1.5,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      {message.content}
    </div>
  </div>
);
